export default class ScrollManager {

    scrollTo(elementSelector, callbackFunction = null, speed = null, onlyScrollIfVisible = null, offsetHeight = null) {

        const elm = document.querySelector(elementSelector);
        if (onlyScrollIfVisible) {
            if (this.isVisible(elm, offsetHeight)) {
                return;
            }
        }
        let startY = this.currentYPosition();
        let stopY = this.elmYPosition(elm);

        if (offsetHeight) {
            stopY += -offsetHeight;
        }

        let distance = stopY > startY ? stopY - startY : startY - stopY;

        if (!speed) {
            let speed = Math.round(distance / 100);
            if (speed >= 150) speed = 150;
        }

        let step = Math.round(distance / 25);
        let leapY = stopY > startY ? startY + step : startY - step;
        let timer = 0;
        let lastIteration = false;

        if (stopY > startY) {
            for (let i = startY; i < stopY; i += step) {
                if ((leapY - step) < stopY) lastIteration = true;
                setTimeout(this._setTimeOutFunction, timer * speed, leapY, callbackFunction, lastIteration);

                leapY += step;
                if (leapY > stopY) leapY = stopY;
                timer++;
            }
            return;
        }

        lastIteration = false;

        for (let i = startY; i > stopY; i -= step) {
            if ((leapY - step) < stopY) lastIteration = true;
            setTimeout(this._setTimeOutFunction, timer * speed, leapY, callbackFunction, lastIteration);

            leapY -= step;
            if (leapY < stopY) leapY = stopY;
            timer++;
        }
        return false;
    }

    _setTimeOutFunction(leapY, callbackFunction, lastIteration) {
        window.scrollTo(0, leapY);
        if (lastIteration) {
            callbackFunction();
        }
    }

    currentYPosition() {
        if (self.pageYOffset) return self.pageYOffset;
        if (document.documentElement && document.documentElement.scrollTop)
            return document.documentElement.scrollTop;
        if (document.body.scrollTop) return document.body.scrollTop;
        return 0;
    }

    elmYPosition(elm) {
        let y = elm.offsetTop;
        let node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
            node = node.offsetParent;
            y += node.offsetTop;
        }
        return y;
    }

    smoothScroll(scrollBy, scrollTo, isUnderScrollTo) {
        let i = scrollBy;
        const self = this;

        if (i < scrollTo && !isUnderScrollTo) {
            setTimeout(() => {
                window.scrollTo(0, i);
                self.smoothScroll(i + 50, scrollTo, isUnderScrollTo);
            }, 10);
        } else if (i > scrollTo && isUnderScrollTo) {
            setTimeout(() => {
                window.scrollTo(0, i);
                self.smoothScroll(i - 50, scrollTo, isUnderScrollTo);
            }, 10);
        }
    }

    isVisible(element, offsetHeight) {
        let rect = element.getBoundingClientRect();
        let rectTop = rect.top;
        if (offsetHeight) {
            rectTop -= offsetHeight;
        }

        return (rect.bottom >= 0) && (rectTop >= 0);
    }

    isElementPartiallyVisible(el, visibilityThreshold = 0.7) {
        const rect = el.getBoundingClientRect();
        const vWidth = window.innerWidth || document.documentElement.clientWidth;
        const vHeight = window.innerHeight || document.documentElement.clientHeight;

        const elementWidth = rect.width;
        const elementHeight = rect.height;
        const elementArea = elementWidth * elementHeight;

        if (elementArea === 0) return false;

        const visibleWidth = Math.max(0, Math.min(rect.right, vWidth) - Math.max(rect.left, 0));
        const visibleHeight = Math.max(0, Math.min(rect.bottom, vHeight) - Math.max(rect.top, 0));
        const visibleArea = visibleWidth * visibleHeight;

        return visibleArea / elementArea >= visibilityThreshold;
    }

}
